<template>
  <a-menu
    v-model="isOpen"
    bottom
    end
    :close-on-content-click="false"
    offset-y
    max-height="300"
    :min-width="chipGroupMaxWidth"
    :z-index="99"
    :disabled="meetingTypeItems.length == 0"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="isDisabled">
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            :width="240"
            color="primaryDark"
            v-bind="attrs"
            v-on="{ ...menu, ...tooltip }"
            class="ml-4 meetingType-filter-btn"
            :disabled="meetingTypeItems.length == 0"
            :style="`height: ${height}px !important;`"
          >
            <v-icon left>mdi-filter</v-icon>
            <span
              style="
                width: 162px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
             {{ label }}
            </span>
            <v-icon size="22" v-if="!isOpen">mdi-chevron-down</v-icon>
            <v-icon size="22" v-else>mdi-chevron-up</v-icon>
          </a-btn>
        </template>
        <span v-html="$t('agenda.tipMeetingTypeFilter')"></span>
    </v-tooltip>
    </template>
    <v-list id="filterListId" dense style="padding: 0" :min-width="240">
      <v-list-item :disabled="allNodesSelected" @click.stop="toggleCompleteSelection" id="selectAllListId">
        <v-list-item-action class="mr-2">
          <v-checkbox
            dense
            :indeterminate="someNodesSelected"
            :input-value="allNodesSelected"
            @click.stop="toggleCompleteSelection"
            :disabled="allNodesSelected"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("agenda.selectAll") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item-group
        v-model="selectedMeetingTypes"
        multiple
        mandatory
        active-class=""
      >
        <template v-for="(item, index) in meetingTypesList">
          <v-list-item
            v-if="$security.checkMeetingTypeAccess(item.id, 'ViewMeeting')"
            :key="index"
            :value="item"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action class="mr-2">
                <v-checkbox dense :input-value="active" :readonly="selectedMeetingTypes.length === 1"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <!-- <v-chip :color="item.color" :dark="isDarkTheme(item.color)" label small> -->
                  {{ item.label }}
                  <!-- </v-chip> -->
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </a-menu>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import MeetingTypeChipGroup from "./MeetingTypeChipGroup.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
export default {
  components: { MeetingTypeChipGroup, ABtn, AMenu },
  name: "MeetingTypeMenuList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      isDisabled: false,
      isOpen: false,
    };
  },
  watch: {
    isOpen(value) {
      this.isDisabled = value ? true : false;
      if (!value) {
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      }
    },
  },
  mounted(){
    this.selectedMeetingTypes = this.meetingTypeItems.map((node) => node);
  },
  computed: {
    ...mapState({
      meetingTypeFilterWidth: (state) => state.agenda.meetingTypeFilterWidth,
    }),
    noNodesSelected() {
      return this.selectedMeetingTypes.length === 0;
    },
    someNodesSelected() {
      return this.selectedMeetingTypes.length > 0 && !this.allNodesSelected;
    },
    allNodesSelected() {
      return this.selectedMeetingTypes.length === this.meetingTypeItems.length;
    },
    chipGroupMaxWidth() {
      return this.meetingTypeFilterWidth - 22;
    },
    ...gettersMap(),
    meetingTypeItems(){
      return this.meetingTypesList.filter((item) => {
        if (this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")) {
          return item;
        }
      });
    },
    label() {
      if (
        this.selectedMeetingTypes.length > 0 &&
        this.selectedMeetingTypes.length == 1
      ) {
        const m_types = Array.prototype.map
          .call(this.selectedMeetingTypes, function (item) {
            return item.label;
          })
          .join(",");
        return m_types;
      } else if (this.selectedMeetingTypes.length > 1 && !this.allNodesSelected) {
        return `${this.selectedMeetingTypes.length} ${this.$t("meetings")}`;
      }
      return this.$t("agenda.lblFilterMeetType");
    },
    selectedMeetingTypes: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
  methods: {
    isDarkTheme(color) {
      return customFunctions.getContrast(color);
    },
    toggleCompleteSelection() {
      if (this.noNodesSelected || this.someNodesSelected) {
        this.selectedMeetingTypes = this.meetingTypeItems.map((node) => node);
      } else {
        this.selectedMeetingTypes = [];
      }
    },
    scrollToTop() {
      document.getElementById("selectAllListId").scrollIntoView({
        behavior: "instant",
        block: "start",
        inline: "start",
      });
    },
  },
};

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>

<style>
</style>